{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Ver todas as opções",
  "Spoiler_Reveal_Tooltip": "Clique para mostrar",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweetar isso",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Item oculto",
  "Spoiler_Reveal_Video_CTA": "Revelar vídeo",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Expandir imagem",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Ver todos os resultados",
  "Spoiler_Reveal_Image_Placeholder": "Essa imagem contém um spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Slider de busca",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Você pode votar em mais de uma resposta.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Mostrar mais controles de áudio",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Fechar",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Carregando {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Avatar do usuário",
  "Preview_ReadMore_Label": "Leia mais",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volume",
  "Spoiler_Reveal_Gallery_Placeholder": "Essa galeria contém um spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Agendar",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Ativar áudio",
  "Spoiler_Reveal_Gallery_CTA": "Revelar galeria",
  "Poll_Viewer_ShowLess_CTA": "Mostrar menos",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Silenciar",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "Mais {{anonNumber}} anônimos",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Seguir",
  "VerticalEmbed_Products_Button": "Comprar",
  "Poll_Viewer_Toast_Error_ServerDown": "Não foi possível conectar ao servidor. Tente novamente mais tarde.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} pessoa votou nessa resposta",
  "Poll_Viewer_VoteCount": "{{number}} votos",
  "VerticalEmbed_Events_Button": "Registrar-se",
  "Spoiler_Reveal_Image_CTA": "Revelar imagem",
  "Poll_Viewer_Toast_Error_Connection": "Sem internet. Verifique sua conexão.",
  "Poll_Viewer_Visibility_Owner_Footer": "Só você pode ver os resultados.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} pessoas votaram nessa resposta",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Item expandido",
  "Audio_Plugin_Cover_Alt": "Capa de áudio",
  "Spoiler_Reveal_Video_Placeholder": "Esse vídeo contém um spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Ver post completo",
  "UploadFile_Viewer_Download": "Fazer download de {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}h",
  "VerticalEmbed_Units_Minute": "{{minutes}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
